import { useInfiniteQuery } from '@tanstack/react-query';

import { getNextPageParam, getPagesContent } from '@pkg/hooks';

import { type WishlistAuditQuery } from '@app/client/common/structs';
import { callAuditLineupItems } from '@app/client/resources/fantasy';

const AUDIT_QUERY_LIMIT = 20;
const AUDIT_QUERY_CACHE = 'AUDIT_QUERY_CACHE';
type UseAuditLineupProps = {
    query?: WishlistAuditQuery;
    disabled?: boolean;
};
export function useAuditLineup({ query, disabled }: UseAuditLineupProps) {
    const cache = [AUDIT_QUERY_CACHE, ...Object.values(query || {})];
    return useInfiniteQuery(
        cache,
        ({ pageParam = 0, signal }) => {
            return callAuditLineupItems({
                type: 'item',
                settings: { signal },
                query: { page: pageParam, limit: AUDIT_QUERY_LIMIT, ...query },
            });
        },
        {
            retry: false,
            keepPreviousData: true,
            select: (res) => {
                return {
                    ...res,
                    pages: getPagesContent(res?.pages),
                };
            },
            getNextPageParam,
            enabled: !disabled,
        },
    );
}
